import { Component, OnInit } from '@angular/core';
import { BookingSlotStateService } from '../../../booking/services/booking-slot-state.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { BookingSlot } from '../../../booking/models/booking-slot';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';
import { BookingOrderService } from '../../../booking/services/booking-order.service';

@Component({
  selector: 'app-kiosk-birthday',
  templateUrl: './kiosk-birthday.component.html',
  styleUrls: ['./kiosk-birthday.component.css']
})
export class KioskBirthdayComponent implements OnInit {

  constructor(
    private bookingSlotStateService: BookingSlotStateService,
    private bookingOrderService: BookingOrderService,
    private kioskStateService: KioskStateService,
    private logger: LoggerService,
  ) { }

  ngOnInit() {
    this.bookingSlotStateService.initialize();
    this.logger.info('KioskBirthdayComponent: bookingSlotStateService initialized.');
  }

  onTimeSlotSelected(timeSlot: BookingSlot) {
    const selectedBookingDate = this.bookingSlotStateService.getSelectedBookingDate(timeSlot);

    this.bookingOrderService.setSelectedBookingDateAndSlots(
      selectedBookingDate,
      this.bookingSlotStateService.timeSlots.filter(x => x.fromTime === timeSlot.fromTime)
    );

    this.kioskStateService.update(KioskStateEnum.SelectBookingEventProducts);
  }
}
